import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import OvertredelseskoderIleggelserUpdateModalContent from "../../OvertredelseskoderIleggelseForm";

import { putOvertredelseskoderIleggelser } from "../../../../actions/overtredelseskoderIleggelserActions";
import {
    IsValidated,
    onChangeValidation,
} from "../../../../utils/validationUtils";

const rules = {
  id: "required;isDigit",
  beskrivelse: "required",
  overtredelseGruppeId: "required",
  belop: "required;isDigit",
  internkode: "required",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isLargerThan=aktivertDato",
  kreverAvstand: "required",
  kreverAutomatinfo: "required",
  kreverBilettnummer: "required",
  kreverUtlopstidBillett: "required",
};

function stateFromProps(ok) {
  return {
    open: false,
    submitButtonText: "Lagre",
    id: ok.id,
    beskrivelse: ok.beskrivelse,
    forklaring: ok.forklaring,
    aktivertDato: ok.aktivertDato,
    deaktivertDato: ok.deaktivertDato,
    kreverAvstand: ok.kreverAvstand,
    kreverAutomatinfo: ok.kreverAutomatinfo,
    kreverBilettnummer: ok.kreverBilettnummer,
    kreverUtlopstidBillett: ok.kreverUtlopstidBillett,
    overtredelseGruppeId: ok.overtredelseGruppe ? ok.overtredelseGruppe.id : "",
    belop: ok.belop,
    aktiv: ok.aktiv,
    overtredelseInternkoder: ok.overtredelseInternkoder,
    validationError: {},
    openDeaktiverConfirm: false,
  };
}

function OvertredelseskoderIleggelser({ overtredelsekoderIleggelse, isOpenCallback }) {
  const dispatch = useDispatch();
  const overtredelsegrupper = useSelector((state) => state.overtredelsegrupper);

  const [state, setState] = useState(() => stateFromProps(overtredelsekoderIleggelse));
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    setState((s) => ({ ...stateFromProps(overtredelsekoderIleggelse), open: s.open }));
  }, [overtredelsekoderIleggelse]);

  useEffect(() => {
    if (isOpenCallback) isOpenCallback(state.open);
  }, [state.open, isOpenCallback]);

  const closeModal = () => setState(stateFromProps(overtredelsekoderIleggelse));
  const openModal = (e) => { e.stopPropagation(); update({ open: true }); };

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePut = () => {
    update({ submitButtonText: "Lagrer..." });
    dispatch(
      putOvertredelseskoderIleggelser(state.id, {
        beskrivelse: state.beskrivelse,
        forklaring: state.forklaring,
        overtredelseGruppeId: state.overtredelseGruppeId,
        belop: state.belop && Number(state.belop),
        aktivertDato: state.aktivertDato || null,
        deaktivertDato: state.deaktivertDato || null,
        kreverAvstand: state.kreverAvstand,
        kreverAutomatinfo: state.kreverAutomatinfo,
        kreverBilettnummer: state.kreverBilettnummer,
        kreverUtlopstidBillett: state.kreverUtlopstidBillett,
      })
    )
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isValid() && !state.deaktivertDato) {
      handlePut();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChangeGroupButtons = (e) => {
    const { name, value } = e.target;
    let val = null;
    if (value === "Kreves") val = true;
    else if (value === "Valgfritt") val = false;
    update({ [name]: val });
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Rediger overtredelseskoder for ileggelser"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={UpdateOpenModal}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <OvertredelseskoderIleggelserUpdateModalContent
          id={state.id}
          overtredelseInternkoder={state.overtredelseInternkoder}
          beskrivelse={state.beskrivelse}
          forklaring={state.forklaring}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          overtredelseGruppeId={state.overtredelseGruppeId}
          overtredelseGrupper={overtredelsegrupper}
          belop={state.belop}
          handleChange={handleChange}
          handleChangeGroupButtons={handleChangeGroupButtons}
          kreverAvstand={state.kreverAvstand}
          kreverBilettnummer={state.kreverBilettnummer}
          kreverAutomatinfo={state.kreverAutomatinfo}
          kreverUtlopstidBillett={state.kreverUtlopstidBillett}
          validationError={state.validationError}
          actionType="update"
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver overtredelseskode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePut}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere overtredelseskode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}

export default OvertredelseskoderIleggelser;
